function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 1920,
  height: 477
}), /*#__PURE__*/React.createElement("filter", {
  x: "-0.7%",
  y: "-2.2%",
  width: "101.4%",
  height: "105.7%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.439215686   0 0 0 0 0.470588235   0 0 0 0 0.529411765  0 0 0 0.24 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.3333333,7.63278329e-17 C15.3858827,6.9388939e-18 15.4384321,0.0061744494 15.4897999,0.0185233482 C15.5041449,0.0219292239 15.517664,0.0256574208 15.5310038,0.0297931983 C15.5390512,0.0323223939 15.5475064,0.0351191625 15.5559139,0.0380896783 C15.5812538,0.0470551459 15.6054505,0.0573197228 15.6288681,0.0689198973 C15.6355953,0.0722084098 15.6423689,0.075703086 15.6490934,0.0793215625 C15.6690571,0.0901357375 15.688291,0.101805366 15.7068569,0.114386587 C15.7412764,0.137636587 15.7741253,0.164649619 15.8047379,0.195262146 L15.7484732,0.144998822 C15.763015,0.156586386 15.7770613,0.168769231 15.7905754,0.181510474 L15.8047379,0.195262146 C15.8095003,0.200024637 15.8141757,0.204841257 15.818764,0.209710026 C15.8312308,0.222938672 15.8434136,0.23698504 15.8550012,0.251526789 C15.8660314,0.265311686 15.876205,0.279154456 15.885777,0.293283113 C15.8981946,0.311709007 15.9098643,0.330942942 15.920558,0.35078063 C15.9242969,0.35763113 15.9277916,0.36440465 15.9311625,0.371223842 C15.9426803,0.394549485 15.9529449,0.418746185 15.9617743,0.443622449 C15.9648808,0.452493621 15.9676776,0.460948823 15.9703006,0.469446126 C15.9743426,0.482336039 15.9780708,0.495855122 15.9813768,0.50953892 C15.9858068,0.528212188 15.9893777,0.546369555 15.9921895,0.564621261 L15.9927716,0.568151553 L16,0.666666667 L16,4.66666667 C16,5.0348565 15.7015232,5.33333333 15.3333333,5.33333333 C14.9651435,5.33333333 14.6666667,5.0348565 14.6666667,4.66666667 L14.6666667,4.66666667 L14.666,2.276 L9.47140452,7.47140452 C9.23708995,7.7057191 8.8717494,7.72915055 8.61122963,7.54169889 L8.52859548,7.47140452 L5.66666667,4.60947571 L1.13807119,9.13807119 C0.87772166,9.39842072 0.455611674,9.39842072 0.195262146,9.13807119 C-0.065087382,8.87772166 -0.065087382,8.45561167 0.195262146,8.19526215 L0.195262146,8.19526215 L5.19526215,3.19526215 C5.45561167,2.93491262 5.87772166,2.93491262 6.13807119,3.19526215 L6.13807119,3.19526215 L9,6.05719096 L13.723,1.333 L11.3333333,1.33333333 C10.9986153,1.33333333 10.7215113,1.08665826 10.673895,0.765181781 L10.6666667,0.666666667 C10.6666667,0.298476833 10.9651435,0 11.3333333,0 L11.3333333,0 Z",
  id: "path-3"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Graphs",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Portfolio-Page---Graph-Gold",
  transform: "translate(-384.000000, -168.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "trending-up",
  transform: "translate(384.000000, 91.333333)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("use", {
  id: "Combined-Shape",
  fill: "currentColor",
  xlinkHref: "#path-3"
})))));

var SvgTrendingUp = function SvgTrendingUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrendingUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trending-up.ed3ed9a4.svg";
export { ForwardRef as ReactComponent };